// import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ROUTER_PATHS, texto } from '@/shared';

import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { ISubcategoriaIncidentes } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useCreateSubcategoriaIncidencia, useUpdateSubcategoriaIncidencia } from '@/shared/actions/erp/subcategoria-incidentes';
import { useFetchCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';


const returnUrlSubcategoriaIncidente = ROUTER_PATHS.ticketSoporteCliente.subcategoria_incidente_nav;

export interface SaveSubcategoriaIncidenteInterface {
  titlePage: string;
  editSubcategoriaIncidente?: ISubcategoriaIncidentes;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  estado: boolean;
  descripcion: string;
  categoria_incidencia: string;
};

const SaveSubcategoriaIncidente: React.FC<SaveSubcategoriaIncidenteInterface> = ({
  titlePage,
  editSubcategoriaIncidente,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  //axios
  const { data: dataCategoriaIncidente, isLoading: isLoadingCatIncident} = useFetchCategoriaIncidentes({ page_size: 600 })

  ///* mutations
  const createCategoryProductMutation = useCreateSubcategoriaIncidencia({
    navigate,
    returnUrl: returnUrlSubcategoriaIncidente
  });
  const updateCategoryProductMutation = useUpdateSubcategoriaIncidencia({
    navigate,
    returnUrl: returnUrlSubcategoriaIncidente
  });

  ///* form
  const form = useForm<SaveFormData>({
    // resolver: yupResolver(newSubcategoriaIncidenteSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;



  ///* handlers
  const onSave = () => {
    if (!isValid) return;
    ///* upd
    if (editSubcategoriaIncidente?.id_subcategoria_incidencia) {
      return updateCategoryProductMutation.mutate({
        id: editSubcategoriaIncidente.id_subcategoria_incidencia,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCategoryProductMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editSubcategoriaIncidente) {
      setShrink(true);
      reset(editSubcategoriaIncidente as any);
    }
  }, [editSubcategoriaIncidente]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlSubcategoriaIncidente);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        name="codigo"
        label="Codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ""}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
        disabled={!!editSubcategoriaIncidente}
      />
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomTextField
        name="descripcion"
        label="Descripción"
        control={form.control}
        defaultValue={form.getValues().descripcion || ""}
        error={errors.descripcion}
        helperText={errors.descripcion?.message}
        shrink={shrink}
      />
      <CustomAutocomplete
        label={texto.categoria_incidente}
        name='categoria_incidencia'
        options={dataCategoriaIncidente?.data.data || []}
        isLoadingData={isLoadingCatIncident}
        defaultValue={form.getValues().categoria_incidencia || ''}
        valueKey={'nombre'}
        actualValueKey={'codigo'}
        control={form.control}
        error={errors.categoria_incidencia}
        helperText={errors.categoria_incidencia?.message}
      />
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveSubcategoriaIncidente;
